import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import uuid from 'uuid';
import { rebaseTransaction as _rebaseTransaction } from './rebase-transaction';

// Do this typedef to make it clear that
// this is a local identifier for a resource for local use

// A store manager responsible for the lifecycle and state management of sync blocks in an editor instance.
// Supports create, read, update, and delete operations for sync blocks.
// Designed to manage local in-memory state and synchronize with an external data provider.
// Handles caching, debouncing updates, and publish/subscribe for local changes.
// Ensures consistency between local and remote state, and can be used in both editor and renderer contexts.
export var SyncBlockStoreManager = /*#__PURE__*/function () {
  function SyncBlockStoreManager(dataProvider) {
    _classCallCheck(this, SyncBlockStoreManager);
    this.syncBlocks = new Map();
    this.dataProvider = dataProvider;
  }
  return _createClass(SyncBlockStoreManager, [{
    key: "setEditorView",
    value: function setEditorView(editorView) {
      this.editorView = editorView;
    }
  }, {
    key: "isSourceBlock",
    value: function isSourceBlock(node) {
      if (node.type.name !== 'syncBlock') {
        return false;
      }
      var _node$attrs = node.attrs,
        resourceId = _node$attrs.resourceId,
        localId = _node$attrs.localId;
      return resourceId.includes(localId);
    }
  }, {
    key: "registerConfirmationCallback",
    value: function registerConfirmationCallback(callback) {
      var _this = this;
      this.confirmationCallback = callback;
      return function () {
        _this.confirmationCallback = undefined;
      };
    }
  }, {
    key: "requireConfirmationBeforeDelete",
    value: function requireConfirmationBeforeDelete() {
      return !!this.confirmationCallback;
    }
  }, {
    key: "createSyncBlockNode",
    value: function createSyncBlockNode() {
      var _this$dataProvider;
      // TODO: EDITOR-1644 - properly implement creation of the synced block
      // below is a temporary implementation for the creation of the synced block
      // the resource id needs to have pageId and content property key in it
      // Note: If the data provider is not set, the resource id will be the local id

      var localId = uuid();
      var sourceId = (_this$dataProvider = this.dataProvider) === null || _this$dataProvider === void 0 ? void 0 : _this$dataProvider.getSourceId();
      var resourceId = sourceId ? "".concat(sourceId, "/").concat(localId) : localId;
      var syncBlockNode = {
        attrs: {
          resourceId: resourceId,
          localId: localId
        },
        type: 'syncBlock'
      };
      this.syncBlocks.set(syncBlockNode.attrs.resourceId, {
        resourceId: syncBlockNode.attrs.resourceId,
        sourceLocalId: syncBlockNode.attrs.localId
      });
      return syncBlockNode;
    }
  }, {
    key: "deleteSyncBlocksWithConfirmation",
    value: function () {
      var _deleteSyncBlocksWithConfirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tr, syncBlockIds) {
        var _this2 = this;
        var confirmed, _this$editorView;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.confirmationCallback) {
                _context.next = 7;
                break;
              }
              this.confirmationTransaction = tr;
              _context.next = 4;
              return this.confirmationCallback();
            case 4:
              confirmed = _context.sent;
              if (confirmed) {
                (_this$editorView = this.editorView) === null || _this$editorView === void 0 || _this$editorView.dispatch(this.confirmationTransaction.setMeta('isConfirmedSyncBlockDeletion', true));
                // Need to update the BE on deletion
                syncBlockIds.forEach(function (_ref) {
                  var resourceId = _ref.resourceId;
                  return _this2.syncBlocks.delete(resourceId);
                });
              }
              this.confirmationTransaction = undefined;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function deleteSyncBlocksWithConfirmation(_x, _x2) {
        return _deleteSyncBlocksWithConfirmation.apply(this, arguments);
      }
      return deleteSyncBlocksWithConfirmation;
    }()
  }, {
    key: "rebaseTransaction",
    value: function rebaseTransaction(incomingTr, state) {
      if (!this.confirmationTransaction) {
        return;
      }
      this.confirmationTransaction = _rebaseTransaction(this.confirmationTransaction, incomingTr, state);
    }
  }]);
}();